import { updateEmployeesBulkSession } from "../../infrastructure/repository/employees-repository";
import { findCompanyId } from "../../infrastructure/repository/company-repository";
import { displayEmployeesEditSummaryPage } from "./displays/display-employees-edit-summary";
import { showErrorMessage } from "../commons/show-error-message";
import { logError, addContextLog } from "../../infrastructure/log";
import { translate } from "../../infrastructure/translate/localization";

export async function saveSessionBulkEmployee(employee) {
  try {
    const companyId = await findCompanyId();
    addContextLog("info", "updateEmployeesBulkSession", "display-screen", {
      companyId,
      employee: employee.id,
    });
    const { data: employees } = await updateEmployeesBulkSession({
      companyId,
      employee,
    });
    displayEmployeesEditSummaryPage({ employees });
  } catch (e) {
    logError(e, `Error to saveSessionBulkEmployee ${employee.id}`);
    showErrorMessage(translate("common-messages.basic-error-message"), true);
  }
}
